import { ToastrService } from "ngx-toastr";
import { cardDetailResModel } from "src/app/card-operations/models/cardBalanceResponse.model";
import { userFavoritesResModel, virtualCardsResModel } from "../../../models/favoriteResponse.model";

export class CardMatchValidator{
    constructor(
        private card: cardDetailResModel,
        private toastr: ToastrService
    ){}

    matchFavoritesAndCards(
        callback: () => any
    ){
        if(this.card.message !== ""){
            this.toastr.info(this.card.message);
        }else if(this.card.message == ""){
            callback();
        }
    }
}